export default __webpack_public_path__ + "static/media/Flexi Tank_Dark2.a487badb.svg";